var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {mortgageData: {average_rate: averageRate}, selectorId, classes} = options;
  classes = classes || "payment_options_fields";
  

__p+='\n\n<select id="'+
((__t=( selectorId ))==null?'':__t)+
'" class="'+
((__t=( classes ))==null?'':__t)+
' selectpicker" data-width="100%">\n  <option value="30yr_fixed" data-term="30" data-rate="'+
((__t=( averageRate.thirty_year_fix ))==null?'':__t)+
'">30-Year Fixed</option>\n  <option value="30yr_fha"   data-term="30" data-rate="'+
((__t=( averageRate.thirty_year_fha ))==null?'':__t)+
'">30-Year Fixed FHA</option>\n  <option value="30yr_va"    data-term="30" data-rate="'+
((__t=( averageRate.thirty_year_va ))==null?'':__t)+
'">30-Year Fixed VA</option>\n  <option value="20yr_fixed" data-term="20" data-rate="'+
((__t=( averageRate.twenty_year_fix ))==null?'':__t)+
'">20-Year Fixed</option>\n  <option value="15yr_fixed" data-term="15" data-rate="'+
((__t=( averageRate.fifteen_year_fix ))==null?'':__t)+
'">15-Year Fixed</option>\n  <option value="10yr_fixed" data-term="10" data-rate="'+
((__t=( averageRate.ten_year_fix  ))==null?'':__t)+
'">10-Year Fixed</option>\n  <option value="71_arm"     data-term="30" data-rate="'+
((__t=( averageRate.seven_one_arm ))==null?'':__t)+
'">7/1 ARM</option>\n  <option value="51_arm"     data-term="30" data-rate="'+
((__t=( averageRate.five_one_arm ))==null?'':__t)+
'">5/1 ARM</option>\n</select>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/payment/loan-type-selector.jst.ejs